const DOCS_KEY = 'wingit_admin_documents_v1';
const LEGACY_SAMPLE_DOC_NAMES = new Set([
  'flying orders book - sample.html',
  'club rules - sample.html',
  'flying orders.html',
  'club rules.html',
  'wingit demo flight operations guide.html',
  'wingit demo member handbook.html',
]);

function stripLegacySampleDocs(docs) {
  return docs.filter(doc => !LEGACY_SAMPLE_DOC_NAMES.has(String(doc?.name || '').trim().toLowerCase()));
}

export function loadAdminDocuments() {
  try {
    const raw = localStorage.getItem(DOCS_KEY);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return [];
    }
    const cleaned = stripLegacySampleDocs(parsed);
    if (cleaned.length !== parsed.length) {
      saveAdminDocuments(cleaned);
    }
    return cleaned;
  } catch (err) {
    return [];
  }
}

export function saveAdminDocuments(docs) {
  const normalized = Array.isArray(docs) ? docs : [];
  const cleaned = stripLegacySampleDocs(normalized);
  localStorage.setItem(DOCS_KEY, JSON.stringify(cleaned));
  return cleaned;
}
